import { render, staticRenderFns } from "./rotation.vue?vue&type=template&id=d4c7d094"
import script from "./rotation.vue?vue&type=script&lang=js"
export * from "./rotation.vue?vue&type=script&lang=js"
import style0 from "../css/rotaion.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports